export enum LocalStorageKey {
  MESSAGES_CONTENT_SELECTED_VARIANTS = "messages-content-selected-variants",
  PROSPECT_LIST_TAB = "prospect-list-tab",
  PROSPECT_LIST_ACTION_FILTER = "prospect-list-action-filter",
  SCRIPT_SUGGESTIONS_COLLAPSED = "script-suggestions-collapsed",
  SCRIPT_CALL_MODE = "script-call-mode",
}

export enum CookieKey {
  REFERRAL_CODE = "referral-code",
  LOCALE = "locale",
  SIDEBAR_OPEN = "sidebar-open",
  CURRENT_PROJECT_ID = "current-project-id",
  CALL_ANALYSIS_PERIOD = "call-analysis-period",
  CALL_ANALYSIS_PERIOD_RANGE = "call-analysis-period-range",
  SELECTED_OFFER = "selected-offer",
  SELECTED_AVATAR = "selected-avatar",
  MESSAGES_CONTENT_SELECTED_OBJECTIVE = "messages-content-selected-objective",
  MESSAGES_CONTENT_SELECTED_CHANNEL = "messages-content-selected-channel",
  MESSAGES_CONTENT_SELECTED_CALL_TYPE = "messages-content-selected-call-type",
}

export const REFERRAL_COOKIE_MAX_AGE = 60 * 60 * 24 * 30;
export const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
export const WORKSPACE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
